import { Items } from './items.model';

export class Pago {
  public nit: string;
  public razonSocial: string;
  public emailEmpresa: string;
  public items: Array<Items>;
  public email: string;
}
